import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Colors from 'Theme/Colors'
import React, { useState, useImperativeHandle } from 'react'
import { ChargePointDetailsTab } from 'Components'
import ChargingTokenTabsSkeleton from './ChargingTokenDetailsTabsSkeleton'

const tabTitles = {
  TransactionLog: 'Transaction Log',
  OperatorUserAction: 'Operator User Action',
}

const ChargingTokenDetailsTabs = React.forwardRef(
  (
    { onValueChange, isLoading, initialIndex, canViewOperatorUserActions },
    ref,
  ) => {
    const [selectedIndex, setSelectedIndex] = useState(initialIndex)
    const handleChange = (event, newValue) => {
      setSelectedIndex(newValue)
      onValueChange(newValue)
    }

    const resetIndex = () => {
      setSelectedIndex(0)
    }

    useImperativeHandle(ref, () => ({
      resetIndex,
    }))

    return (
      <div>
        {isLoading ? (
          <ChargingTokenTabsSkeleton
            tabsCount={
              Object.keys(tabTitles).length - +!canViewOperatorUserActions
            }
          />
        ) : (
          <Tabs
            value={selectedIndex}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: Colors.primary,
              },
            }}
          >
            {Object.values(tabTitles).map((title, index) =>
              title === tabTitles.OperatorUserAction ? (
                canViewOperatorUserActions ? (
                  <Tab
                    sx={{ padding: '0px' }}
                    key={index}
                    label={
                      <ChargePointDetailsTab
                        title={title}
                        isSelected={selectedIndex === index}
                      />
                    }
                  />
                ) : null
              ) : (
                <Tab
                  sx={{ padding: '0px' }}
                  key={index}
                  label={
                    <ChargePointDetailsTab
                      title={title}
                      isSelected={selectedIndex === index}
                    />
                  }
                />
              ),
            )}
          </Tabs>
        )}
      </div>
    )
  },
)

ChargingTokenDetailsTabs.propTypes = {
  onValueChange: PropTypes.func,
  isLoading: PropTypes.bool,
  initialIndex: PropTypes.number,
  canViewOperatorUserActions: PropTypes.bool,
}

export default ChargingTokenDetailsTabs
